import { render, staticRenderFns } from "./CompEcommerceQR.vue?vue&type=template&id=80f73a7e"
import script from "./CompEcommerceQR.vue?vue&type=script&setup=true&lang=js"
export * from "./CompEcommerceQR.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports